import React, {useEffect} from "react";
import Header from "../../../components/header/header";
import Footer from "../../../components/footer/footer";
import "../styles/mainlayout.scss";

interface IMainLayout {
    children: React.ReactNode;
}

const MainLayout = ({children}: IMainLayout) => {
    useEffect(()=> {
        document.body.style.backgroundColor = "#F5F5F5"
    },[])
    return (
        <>
            <Header/>
            {children}
            <Footer/>
        </>
    );
}

export default MainLayout;